import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import { navHome, } from 'redux/actions'

import Component from './component'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      navHome,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/Four0FourScene/index.js